import React from 'react';

export default function useIntrastatHints() {
  const modeOfTransportHint = (
    <>
      Code must be a single digit:
      <br />1 – Sea Transport
      <br />2 – Rail Transport
      <br />3 – Road Transport
      <br />4 – Air Transport
      <br />5 – Postal Consignment
      <br />7 – Fixed Installations
      <br />8 – Inland Waterway
      <br />9 – Own Propulsion
    </>
  );

  const natureOfTransactionHint = (
    <>
      Code must be two digits:
      <br />
      11 – Sale or purchase
      <br />
      12 – Return of goods
      <br />
      13 – Processing under contract
      <br />
      14 – After processing
      <br />
      19 – Other transactions
      <br />
      21 – Financial leasing
      <br />
      30 – Triangular trade
      <br />
      91 – Hire, loan, or temporary use
      <br />
      99 – Other
    </>
  );

  const customsProcedureCodeHint = "Code must be of the format '99-99-999'";

  return {
    modeOfTransportHint,
    natureOfTransactionHint,
    customsProcedureCodeHint,
  };
}
